import { useState, useEffect } from 'react';
import { TicketState } from '../../services/TicketState';

export const useTicketState = (ticket) => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        var open = ((ticket || {}).ticketState || {}).identifier === TicketState.OPEN;
        if (open !== isOpen) {
            setIsOpen(open);
        }
    }, [((ticket || {}).ticketState || {}).identifier])

    return isOpen;
}
